/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTaxRegimesQuery } from '../../models/get-tax-regimes-query';
import { TaxRegimeDtoSearchResponse } from '../../models/tax-regime-dto-search-response';

export interface GetTaxRegimesAsync$Plain$Params {
  query?: GetTaxRegimesQuery;
}

export function getTaxRegimesAsync$Plain(http: HttpClient, rootUrl: string, params?: GetTaxRegimesAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxRegimeDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, getTaxRegimesAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxRegimeDtoSearchResponse>;
    })
  );
}

getTaxRegimesAsync$Plain.PATH = '/api/tax-regime';
